import React, { useEffect, useRef, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { logger } from '../../../utils';
import { Spinner } from '../../../assets/Spinner';
import { PaginationSkeleton } from './PaginationSkeleton';

type Props = {
  pageSize?: number;
  pageIndex?: number;
  count?: number;
  hasNextPage?: boolean;
  loading?: boolean;
  onChangePageSize?: any;
  onChangePageIndex?: any;
};

export function Pagination(props: Props): JSX.Element {
  const { pageSize = 10, pageIndex = 1, count, hasNextPage, loading, onChangePageIndex, onChangePageSize, } = props;
  const pageNumbers = count != null
    ? Math.max(1, Math.ceil(count / pageSize))
    : (hasNextPage ? pageIndex + 1 : pageIndex);
  const pageSizeOptions = [10, 20, 30, 50, 100, 1000];
  const [isPageSizeMenuOpen, setIsPageSizeMenuOpen] = useState(false);
  const pageSizeMenuRef = useRef<HTMLDivElement>(null);


  const handlePageClick = (event: any) => {
    onChangePageIndex?.(parseInt(`${event.selected}`) + 1);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pageSizeMenuRef.current &&
        !pageSizeMenuRef.current.contains(event.target as Node)
      ) {
        setIsPageSizeMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="col-12 mt-2 mb-2 pb-1">
      <div className="row align-items-start">
        <div className="col-12 col-sm-6 mb-3 mb-sm-0">
          <div className="d-flex align-items-center flex-wrap">
            <div className="dropdown" ref={pageSizeMenuRef}>
              <button
                type="button"
                className="btn border-grey dropdown-toggle bg-surface"
                id="page-count-filter"
                aria-haspopup="true"
                aria-expanded={isPageSizeMenuOpen}
                onClick={() => {
                  setIsPageSizeMenuOpen((prev) => !prev);
                }}
              >
                {pageSize}
              </button>
              <div
                className={`dropdown-menu page-counter p-0${isPageSizeMenuOpen ? ' show' : ''}`}
                aria-labelledby="page-count-filter"
              >
                {
                  pageSizeOptions.map((size: number, index) => (
                    <button
                      type="button"
                      key={index}
                      className="dropdown-item"
                      onClick={() => {
                        onChangePageSize(size);
                        setIsPageSizeMenuOpen(false);
                      }}
                    >
                      {size}
                    </button>
                  ))
                }
              </div>
            </div>
            <div>
              <p className="mb-0  me-auto me-auto ms-3 ms-sm-3 ms-lg-2 ms-md-3 text-muted">
                {" "}
                Results per page
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <nav aria-label=" table Page navigation">
            {(loading || (!pageIndex || (pageIndex > 1 && count === 0))) ? (
              <div className="d-flex align-items-end justify-content-end">
                <PaginationSkeleton />
              </div>
            ) : (
              <ul className="pagination justify-content-sm-end">
                <ReactPaginate
                  nextLabel=">"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={2}
                  pageCount={pageNumbers}
                  previousLabel="<"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active"
                  forcePage={pageIndex ? pageIndex - 1 : 0}
                />
              </ul>)}

          </nav>
        </div>
      </div>
    </div>
  );
}
